//TODO: Typescritp: Consolidate with types.ts
export type currencyObject = {
   Code: string
   Rate: number
   Name: string
   Symbol: string
   Thousand_separator: string
   Decimal_separator: string
}

export enum coreProductType {
   None = 'core0',
   Core = 'core1',
   Pro = 'core2',
   Elite = 'core3',
}

export enum SFDealDeskType {
   NewSaleHRISImplementation = 'New Sale HRIS Implementation',
   ExpansionSaleHRISImplementation = 'Expansion Sale HRIS Implementation',
   QuickStart = 'Quickstart',
   PayrollSaleHRISImplementation = 'Payroll Sale Implementation',
}

export type ProductBand = {
   Id: number
   ProductCode: string
   ProductBandID: number
   Book: number
   BasePrice: number
   EmpLow: number
   EmpHigh: number
   CountryMultiplier: number
}

export type Discount = {
   AccountFlags: string
   Regions?: string
   AlwaysApply: boolean
   DefaultOn: boolean
   ApplyTo: string
   BillingFreq: string
   BookId: number
   DependsOn: string
   DiscId: number
   Disclaimer: string
   DiscountAmount: number
   DiscountCode: string
   DiscountDescription: string
   DiscountName: string
   DiscountType: string
   DisplayOrder: number
   EmpHigh: number
   EmpLow: number
   EndDt: string
   HeroDiscount: boolean
   InputType: string
   LookupAmountField: string
   LookupProduct: string
   LookupProductField: string
   MinRequiredPrepayme: string
   OpportunityTypes: string
   Priority: number
   ProductFamily: string
   PromoUTM: string
   Promotional: boolean
   RequiredProducts: string
   RoleRequired: string
   ShowDisclaimerOn: string
   StartDt: string
   SFDealDeskType: SFDealDeskType
   // Commission fields for deal desk discounts
   AppliesToCommission?: boolean
   CommissionDiscountAmount?: number | null
   // Month range for prepayment discounts
   StartMonth?: number | null
   EndMonth?: number | null
   // Additional fields
   MinRequiredPrepayment?: string
   MaxDiscount?: number
}

export enum ProductInputType {
   Boolean = 'boolean',
   Integer = 'integer',
   Decimal = 'decimal',
}

export type Product = {
   AltProductQuoteDesc: string | null
   BasePrice: number | null
   BillingFreq: string | null
   BookId: number | null
   DisplayOrder: number | null
   EmpHigh: number | null
   EmpListPrice: number | null
   EmpLow: number | null
   MinimumEmployees: number | null
   MinimumListPrice: number | null
   MostRecentCommissionableMRRFields: string | null
   MostRecentExpectedMRRFields: string | null
   PreviousCommissionableMRRFields: string | null
   PreviousExpectedMRRFields: string | null
   CurrentPricingField: string | null
   CurrentPricingCurrencyField: string | null
   DiscountCodeForPricingAdjustment: string | null
   ProductCode: string | null
   ProductDesc: string | null
   ProductFamily: string | null
   TermLengthMin: number | null
   TermLengthMax: number | null
   ProductId: number | null
   ProductName: string | null
   ProductQuoteDesc: string | null
   SFPricebookEntryID: string | null
   SFProduct2Id: string | null
   UpdateDt: string | null
   VolumeCurve: string | null
   InputType: ProductInputType
   Dynamic: boolean
   IsPEPM: boolean
   IsProrated: boolean
   //TODO: change to Set<string>
   RoleRequired: string
   IncludeInActivation: boolean
   UseHeadcountOf: Set<string>
   DependsOn: string | null
   OverrideRoles: Set<string>
   ShowOnScreen: Set<string>
   MRRFunction: string | null
   productBands: ProductBand[] | null
}

export type timeClockDetail = {
   count: number
   timeClockCode: string
}

export type serviceDetails = {
   count: number
   serviceCode: string
}

export type EINIntegrationSelection = {
   integrationType: string
   solutionCode: string
   solutionCost: number
}
